import { render, staticRenderFns } from "./announcement-banner.component.vue?vue&type=template&id=b367e258&"
import script from "./announcement-banner.component.vue?vue&type=script&lang=ts&"
export * from "./announcement-banner.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports